import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import { getSecretTOTP, getSecretTOTPReset, removeSecretTOTP } from '../services/actions';
import { selectActiveTOTP, selectGetSecretTOTPApi, selectSecretTOTPS } from '../services/selectors';
import type { Secret, TOTP } from '../types';

export interface UseTOTPOptions {
    autofetch?: boolean;
    isPubliclyShared?: boolean;
}
export const useTOTP = (id: Secret['id'], options: UseTOTPOptions) => {
    const totps = useAppSelector(state =>
        selectSecretTOTPS(state, {
            id,
        }),
    );

    const { inProgress } = useAppSelector(state => selectGetSecretTOTPApi(state, id));

    const activeTotp = useAppSelector(state =>
        selectActiveTOTP(state, {
            id,
        }),
    );

    const dispatch = useDispatch();

    const getTOTP = () => {
        dispatch(getSecretTOTP(id));
    };

    const removeTOTP = (code: TOTP['code']) => {
        dispatch(removeSecretTOTP(id, code));
    };

    useEffect(() => {
        if ((!activeTotp || totps.length === 1) && options.autofetch && !inProgress) {
            dispatch(getSecretTOTP(id, options.isPubliclyShared));
        }
    }, [activeTotp, totps, id, dispatch, options, inProgress]);

    useEffect(
        () => () => {
            dispatch(getSecretTOTPReset(id));
        },
        [id, dispatch],
    );

    return { activeTotp, getTOTP, removeTOTP };
};
